import { useMemo } from "react";
import { Card, CardContent } from "../../../client/components/ui/card";
import { CardSectionHeader } from "../../../client/components/ui/card-section-header";
import { useLanguageContext } from "../../../client/contexts/LanguageContext";
import useTranslation from "../../../client/hooks/useTranslation";
import { makeFormat } from "../../../lite/lib/format";
import { UpcomingChargesPanel, type PanelCharge } from "../../../prop-firm-manager/upcoming/UpcomingChargesPanel";
import { useDashboardData } from "../DashboardDataContext";

/** Prélèvements à venir, échéances à confirmer et questions de résiliation :
 *  même panneau que la carte « À venir » du Lite. Les charges viennent du
 *  contexte (getAccountChargesByUser, non filtrées, occurrences comprises).
 *  En lecture seule (vue mentor, aperçu partagé), aucune action. */
export default function PropFirmUpcomingChargesWidget() {
  const t = useTranslation();
  const { language } = useLanguageContext();
  const fmt = useMemo(() => makeFormat(language), [language]);
  const { charges: rawCharges, isDark, readOnly } = useDashboardData();
  const charges = (rawCharges ?? []) as PanelCharge[];
  const accountName = (c: PanelCharge) =>
    c.accountId ? c.account?.name ?? "" : t.lite.pfm.upcoming.global;

  return (
    <Card className="h-full flex flex-col">
      <CardSectionHeader label={t.dashboard.widgets.propfirmUpcomingCharges} isDark={isDark} compact />
      <CardContent className="flex-1 overflow-auto p-4">
        <UpcomingChargesPanel charges={charges} fmt={fmt} accountName={accountName} readOnly={readOnly} />
      </CardContent>
    </Card>
  );
}
